// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__6FWJc","signatureBlock":"Footer_signatureBlock__2LpfU","signature":"Footer_signature__1acVT"};